<main class="container mat-typography">
  <router-outlet></router-outlet>
</main>
